import Isotope from "isotope-layout";


var elem = document.querySelectorAll('.historique__content .historique__images');

elem.forEach(el => {
    var iso = new Isotope( el, {
        itemSelector: '.image',
        percentPosition: true
    });
});
